import { SidebarContent } from '@/shared/types/sidebar';

/**
 * Maps sidebar content from one category to the equivalent content for another category.
 * If the content is datasource_details or details, it remains unchanged.
 * Otherwise, it maps to the equivalent add/upload view for the target category.
 *
 * @param previousContent - The sidebar content that was displayed before switching categories
 * @param targetCategory - The target category to map the sidebar content to
 * @returns The mapped sidebar content for the target category
 */
export const mapSidebarContentToCategory = (
  previousContent: SidebarContent,
  targetCategory: string | undefined
): SidebarContent => {
  // If previous content was details/info, keep it as datasource_details
  if (previousContent === 'datasource_details' || previousContent === 'details') {
    return 'datasource_details';
  }

  // Map category-specific content to equivalent for target category
  switch (targetCategory) {
    case 'faq':
      // Map from other categories to FAQ equivalents
      if (
        previousContent === 'add_txt_document' ||
        previousContent === 'add_webpages' ||
        previousContent === 'add_external_sources'
      ) {
        return 'add_faq';
      }
      if (previousContent === 'upload_documents') {
        return 'upload_faq';
      }
      return 'add_faq';
    case 'documents':
      // Map from other categories to Documents equivalents
      if (
        previousContent === 'add_faq' ||
        previousContent === 'add_webpages' ||
        previousContent === 'add_external_sources'
      ) {
        return 'add_txt_document';
      }
      if (previousContent === 'upload_faq') {
        return 'upload_documents';
      }
      return 'add_txt_document';
    case 'webpages':
      // Map from other categories to Webpages equivalent
      if (
        previousContent === 'add_faq' ||
        previousContent === 'add_txt_document' ||
        previousContent === 'add_external_sources'
      ) {
        return 'add_webpages';
      }
      if (previousContent === 'upload_faq' || previousContent === 'upload_documents') {
        return 'add_webpages';
      }
      return 'add_webpages';
    case 'external':
      // Map from other categories to External Sources equivalent
      if (
        previousContent === 'add_faq' ||
        previousContent === 'add_txt_document' ||
        previousContent === 'add_webpages'
      ) {
        return 'add_external_sources';
      }
      if (previousContent === 'upload_faq' || previousContent === 'upload_documents') {
        return 'add_external_sources';
      }
      return 'add_external_sources';
    default:
      return 'datasource_details';
  }
};
